import { UsersApi } from 'services/ApiService';
import { logError } from 'services/logger';
import { useQuery } from '@tanstack/react-query';

const USER_INFO_QUERIE_KEY = 'userInfoQuerie';

const keys = {
    getUserInfo: (icId: string | undefined) => [USER_INFO_QUERIE_KEY, 'getUserInfo', icId],
};

export const useGetUserInfo = (icId: string | undefined) => {
    const getUserInfo = async (icId: string)  => {
        try {
            return await UsersApi.get(icId);
        }
        catch (error) {
            logError(error);
            throw error;
        }
    };

    return useQuery({
        queryKey: keys.getUserInfo(icId),
        queryFn: () => getUserInfo(icId ?? ''),
        enabled: !!icId,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
